import React, {forwardRef} from 'react';

interface EmailInputProps {
    id?: string;
    value: string;
    onChange: (value: string) => void;
    className?: string;
    placeholder?: string;
}

const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
    ({ id = "emailInput", value, onChange, className = "", placeholder = "Enter email address" }, ref) => {
        return (
            <input
                ref={ref}
                id={id}
                type="email"
                className={className}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                autoComplete="email"
                inputMode="email"
                autoCapitalize="none"
                spellCheck={false}
            />
        );
    }
);

export default EmailInput;
